import './styles.scss';
import { ReactElement, useMemo } from 'react';
import EditableCell, { EditableCellProps } from '../EditableCell';
import DateInput from '@/components/DateInput';
import { getClasses } from '@/utils';

export type EditableDateCellProps = Omit<EditableCellProps, 'as' | 'value'> & {
  format?: string;
  value: string[];
};

const EditableDateCell = ({ format, ...props }: EditableDateCellProps): ReactElement => {
  const CustomDateInput = useMemo(
    () =>
      ({ value, onChange }) => <DateInput.New value={value} onChange={onChange} format={format} placeholder="--" />,
    [format]
  );
  return <EditableCell as={CustomDateInput} {...props} className={getClasses('EditableDateCell', props.className)} />;
};
export default EditableDateCell;
